/**
 * Login container.
 * @module components/theme/Sitemap/Sitemap
 * Customization:
 * - use custom action in order to fix navigation action race condition
 * - change depth to 3
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { asyncConnect } from '@plone/volto/helpers';
import { defineMessages, injectIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import { Helmet } from '@plone/volto/helpers';
import { Link } from 'react-router-dom';
import config from '@plone/volto/registry';

import { getSitemap } from '@package/actions';

const messages = defineMessages({
  Sitemap: {
    id: 'Sitemap',
    defaultMessage: 'Sitemap',
  },
});
/**
 * Sitemap class.
 * @class Sitemap
 * @extends Component
 */
class Sitemap extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    getSitemap: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { settings } = config;
    if (settings.isMultilingual) {
      this.props.getSitemap(`${this.props.lang}`, 3);
    } else {
      this.props.getSitemap('', 3);
    }
  }

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */

  renderItems = (items) => {
    return (
      <ul>
        {items.map((item) => (
          <li
            key={item.url}
            className={item.items?.length > 0 ? 'with-children' : ''}
          >
            <Link to={item.url}>{item.title}</Link>
            {item.items && this.renderItems(item.items)}
          </li>
        ))}
      </ul>
    );
  };
  render() {
    const { items } = this.props;
    return (
      <div id="page-sitemap">
        <Helmet title={this.props.intl.formatMessage(messages.Sitemap)} />
        <Container className="view-wrapper">
          <h1>{this.props.intl.formatMessage(messages.Sitemap)} </h1>
          {items && this.renderItems(items)}
        </Container>
      </div>
    );
  }
}

export const __test__ = compose(
  injectIntl,
  connect(
    (state) => ({
      items: state.sitemap.items,
      lang: state.intl.locale,
    }),
    { getSitemap },
  ),
)(Sitemap);

export default compose(
  injectIntl,
  connect(
    (state) => ({
      items: state.sitemap.items,
      lang: state.intl.locale,
    }),
    { getSitemap },
  ),
  asyncConnect([
    {
      key: 'sitemap',
      promise: ({ location, store: { dispatch, getState } }) => {
        const { settings } = config;
        const lang = getState().intl.locale;
        if (settings.isMultilingual) {
          return __SERVER__ && dispatch(getSitemap(`${lang}`, 3));
        } else {
          return __SERVER__ && dispatch(getSitemap('', 3));
        }
      },
    },
  ]),
)(Sitemap);
